import React from 'react'
import { Expander, ExpanderHeader, ExpanderContent, Separator, InputChips } from '@fs/zion-ui'

export default function ChipUnfilteredExpander({ headerText, chipCollection }) {
  return (
    <Expander initiallyOpen>
      <ExpanderHeader>{headerText}</ExpanderHeader>
      <Separator />
      <ExpanderContent>
        <InputChips chipCollection={chipCollection} isSelectable />
      </ExpanderContent>
      <Separator />
    </Expander>
  )
}
